import gql from 'graphql-tag'

export const PUT_PROGRAMS = gql`
  mutation PutPrograms($programInput: [ProgramsInput!]!) {
    putPrograms(programInput: $programInput) {
      Success
    }
  }
`
